export default class StoreValueModel {
    constructor() {
        this.list = []
        this.value = {}
    }
    type=  'value' // 'list'
    value: any
    list: any[] = []
    updatedAt = 0
}
